import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { LateralMenu, TopMenu } from './components/PageMenu';
import Home from './pages/home/Home';
import UnitsPage from './pages/units/UnitsPage';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import UnitFormPage from './pages/units/UnitFormPage';
import ProductsPage from './pages/products/ProductsPage';
import { ToastProvider } from './context/ToastContext';
import ProductFormPage from './pages/products/ProductFormPage';
import UsersPage from './pages/users/UsersPage';
import UserFormPage from './pages/users/UserFormPage';
import ConnectionsPage from './pages/suppliers/SuppliersPage';
import AddConnectionPage from './pages/suppliers/AddSupplierPage';
import MovementsPage from './pages/movements/MovementsPage';
import ClientsPage from './pages/clients/ClientsPage';
import OrdersPage from './pages/orders/OrdersPage';
import PriceTablesPage from './pages/price-tables/PriceTablesPage';
import NewPriceTablePage from './pages/price-tables/NewPriceTablePage';
import IndustryConfigurations from './pages/industry-configurations/IndustryConfigurations';
import NewSale from './pages/new-sale/NewSale';

const Layout = () => (
  <>
    <TopMenu/>
    <div className='h-screen hidden md:flex flex-column border-right-1 border-200 p-4' style={{ minWidth: 300 }}>
      <LateralMenu/>
    </div>
    <div className='h-screen flex-grow-1 px-3 md:px-5 pt-5 md:pt-7 overflow-y-scroll	'>
      <Outlet/>
    </div>
  </>
);

const router = createBrowserRouter([{
  path: "/",
  element: <Layout/>,
  children: [{
    path: '/',
    element: <Home/>
  }, {
    path: 'units',
    element: <UnitsPage/>
  }, {
    path: 'units/:id',
    element: <UnitFormPage/>
  }, {
    path: 'products',
    element: <ProductsPage/>
  }, {
    path: 'products/:id',
    element: <ProductFormPage/>
  }, {
    path: 'users',
    element: <UsersPage/>
  }, {
    path: 'users/:id',
    element: <UserFormPage/>
  }, {
    path: 'suppliers',
    element: <ConnectionsPage/>
  }, {
    path: 'suppliers/new',
    element: <AddConnectionPage/>
  }, {
    path: 'movements',
    element: <MovementsPage/>
  }, {
    path: 'clients',
    element: <ClientsPage/>
  }, {
    path: 'orders',
    element: <OrdersPage/>
  }, {
    path: 'price-tables',
    element: <PriceTablesPage/>
  }, {
    path: 'price-tables/:id',
    element: <NewPriceTablePage/>
  }, {
    path: 'industry-configurations',
    element: <IndustryConfigurations/>
  }, {
    path: 'new-sale/:id',
    element: <NewSale/>
  }]
}]);

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <UserProvider>
          <div className="App w-screen h-screen flex flex-column md:flex-row">
            <RouterProvider router={router} />
          </div>
        </UserProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
